import { render, staticRenderFns } from "./EstbalishmentViewSalesOrdersAddSalesOrderModal.vue?vue&type=template&id=3bc4a328"
import script from "./EstbalishmentViewSalesOrdersAddSalesOrderModal.vue?vue&type=script&lang=js"
export * from "./EstbalishmentViewSalesOrdersAddSalesOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports